<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      :persistent="true"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>添加</v-toolbar-title>
          <!-- 中间的空 -->
          <v-spacer>
            <v-btn class="ma-4 md=4" @click="editName">
              配置他/她
            </v-btn>
          </v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dialog = false">
              确定
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-form ref="vform" @submit.prevent="onSubmit">
          <v-container>
            <v-row style="margin-top: 10px;">
              <v-col cols="12" sm="12">
                <v-combobox
                  v-model="form.name"
                  :items="nameArr"
                  item-text="name"
                  item-value="name"
                  label="他/她"
                  counter="10"
                  required
                  :rules="rules.nameRules"
                  :return-object="false"
                  solo
                ></v-combobox>
              </v-col>
              <v-col cols="12" sm="12">
                <v-combobox
                  v-model="form.tag"
                  :items="tagArr"
                  item-text="name"
                  item-value="name"
                  label="标签"
                  counter="10"
                  required
                  :rules="rules.tagRules"
                  :return-object="false"
                  solo
                ></v-combobox>
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea
                  solo
                  name="input-7-4"
                  v-model="form.textarea"
                  :rules="rules.textarea"
                  label="事件描述"
                  prop="textarea"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12">
                <el-form
                  ref="form"
                  :label-position="`top`"
                  :model="form"
                  label-width="80px"
                  :rules="elRules"
                >
                  <el-form-item label="开始时间" prop="startTime">
                    <el-date-picker
                      style="width: 100%;"
                      v-model="form.startTime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm:ss"
                      type="datetime"
                      placeholder="选择开始时间"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker
                      style="width: 100%;"
                      v-model="form.endTime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm:ss"
                      type="datetime"
                      placeholder="选择结束时间"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-form>
              </v-col>
              <v-col cols="12">
                <v-btn color="primary" @click="onSubmit">提交</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <editName ref="editName" @updateList="updateList"></editName>
  </v-row>
</template>
<script>
import editName from "./editName.vue";
import { nameList, eventAdd, tagList } from "@/api/node.js";
import moment from "moment";
export default {
  name: "node-study",
  components: { editName },
  data() {
    return {
      dialog: false,
      form: {
        name: "",
        textarea: "",
        tag: "",
        startTime: moment().format("YYYY-MM-DD HH:mm:ss"),
        endTime: moment()
          .add(1, "hours")
          .format("YYYY-MM-DD HH:mm:ss")
      },
      rules: {
        nameRules: [
          v => !!v || "请输入内容",
          v => {
            if (typeof v == "object") {
              return true;
            } else if (v.length <= 10) {
              return true;
            } else {
              return false || "超过10个字符";
            }
          }
        ],
        tagRules: [
          v => !!v || "请输入内容",
          v => {
            if (typeof v == "object") {
              return true;
            } else if (v.length <= 10) {
              return true;
            } else {
              return false || "超过10个字符";
            }
          }
        ],
        textarea: [v => !!v || "请输入内容"]
      },
      elRules: {
        startTime: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        endTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change"
          }
        ]
      },
      nameArr: [],
      tagArr: []
      // time: null,
    };
  },
  created() {
    this.nameList();
    this.tagList();
  },
  watch: {
    dialog: {
      handler(val) {
        if (val) {
          this.nameList();
          this.tagList();
        }
      }
    }
  },
  methods: {
    updateList() {
      this.nameList();
      this.form.name = "";
    },
    onSubmit() {
      if (this.$refs.vform.validate()) {
        this.$refs.form.validate(valid => {
          if (valid) {
            eventAdd(this.form)
              .then(() => {
                this.$message.success("添加成功");
                this.dialog = false;
                this.$emit("updateEvent");
                this.form = {
                  name: "",
                  textarea: "",
                  tag: "",
                  startTime: moment().format("YYYY-MM-DD HH:mm:ss"),
                  endTime: moment()
                    .add(1, "hours")
                    .format("YYYY-MM-DD HH:mm:ss")
                };
              })
              .catch(err => {
                console.log(err);
                this.$message.error("添加失败");
              });
          }
        });
      }
    },
    editName() {
      this.$refs.editName.dialog = true;
    },
    nameList() {
      nameList().then(res => {
        this.nameArr = res.data;
      });
    },
    tagList() {
      tagList().then(res => {
        this.tagArr = res.data;
      });
    }
  }
};
</script>
